
import React from 'react';
import SkeletonLoader from './SkeletonLoader';

const TransactionCardSkeleton = () => (
  <div className="bg-gray-800/70 p-3 rounded-lg flex items-center gap-4">
    <SkeletonLoader className="w-6 h-6 rounded-full flex-shrink-0" />
    <div className="flex-grow">
      <SkeletonLoader className="h-5 w-3/4 mb-2" />
      <SkeletonLoader className="h-3 w-1/2" />
    </div>
    <SkeletonLoader className="h-6 w-16 flex-shrink-0" />
  </div>
);

const HistoryTabSkeleton = () => {
  return (
    <div className="animate-fadeIn space-y-3 max-h-[60vh] overflow-y-auto custom-scrollbar pr-2">
      {[...Array(6)].map((_, i) => (
        <TransactionCardSkeleton key={i} />
      ))}
    </div>
  );
};

export default HistoryTabSkeleton;
